import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ValidationImageService {

  private regExp = /data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/;
  private imageMIMETypes = ['image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml'];
  private videoMIMETypes = ['video/x-msvideo', 'video/webm', 'video/ogg', 'video/mp4', 'video/quicktime'];

  constructor() { }

  public toBase64(file) {
    return new Observable<any>(
      (observable) => {
        try {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = function () {
            observable.next(reader.result);
          };
        } catch (e) {
          observable.error('validation-images.snackbar messages.to base64 error');
        }
      }
    );
  }

  public validateImageMIMEType(file) {
    return new Observable<any>(
      (observable) => {
        if (this.isSupportedImage(file)) {
          observable.next(file);
        } else {
          observable.error('validation-images.snackbar messages.not image error');
        }
      }
    );
  }

  public validateVideoMIMEType(file) {
    return new Observable<any>(
      (observable) => {
        if (this.isSupportedVideo(file)) {
          observable.next(file);
        } else {
          observable.error('validation-images.snackbar messages.not video error');
        }
      }
    );
  }

  private isSupportedImage(file) {
    if (this.imageMIMETypes.indexOf(file.match(this.regExp)[1]) !== -1) {
      return true;
    } else {
      return false;
    }
  }

  private isSupportedVideo(file) {
    if (this.videoMIMETypes.indexOf(file.match(this.regExp)[1]) !== -1) {
      return true;
    } else {
      return false;
    }
  }
}
